export default __webpack_public_path__ + "static/media/FileText.b8e2dea6.svg";